import { currentPlatform, PLATFORMS } from "./index";
import * as androidLauncher from "./android/appLauncher";
import * as lgLauncher from "./lg/appLauncher";

/**
 * Launch an application on the current platform
 * @param {Object} app The app object containing app_id and other properties
 * @returns {Promise<boolean>} Success status of the launch
 */
export const launchApp = async (app) => {
  switch (currentPlatform) {
    case PLATFORMS.ANDROID:
      return androidLauncher.launchApp(app);

    case PLATFORMS.LG:
      return await lgLauncher.launchApp(app);

    default:
      console.warn("App launching not supported on this platform");
      return false;
  }
};
